import { Component, OnInit } from '@angular/core';
import { ActivatedRoute}  from '@angular/router';

@Component({
  selector: 'app-step5-data',
  templateUrl: './step5-data.component.html',
  styleUrls: ['./step5-data.component.scss']
})
export class Step5DataComponent implements OnInit {
  
  dataStep5 = [
    {
      position: 51, 
      tittle: "5.1 Establecer por escrito, implantar, mantener y difundir en el centro de trabajo una política de prevención de riesgos psicosociales que contemple",
      informacion: "5.1 Establecer por escrito, implantar, mantener y difundir en el centro de trabajo una política de prevención de riesgos psicosociales que contemple",
    },
    {
      position: 57, 
      tittle: "5.7 Difundir y proporcionar información a los trabajadores",
      informacion: "5.7 Difundir y proporcionar información a los trabajadores sobre: ",
   
    },{
      position: 58, 
      tittle: "5.8 Llevar los registros sobre:",
      informacion: "5.8 Llevar los registros sobre"+
      "a) Los resultados de la identificación y análisis de los factores de riesgo psicosocial y, además, tratándose de centros de trabajo de más de 50 trabajadores, de las evaluaciones del entorno organizacional;"+
      "b) Las medidas de control adoptadas cuando el resultado de la identificación y análisis de los factores de riesgo psicosocial y evaluación del entorno organizacional lo señale, y"+
      "c) Los nombres de los trabajadores a los que se les practicaron los exámenes o evaluaciones clínicas y que se comprobó la exposición a factores de riesgo psicosocial, a actos de violencia laboral o acontecimientos traumáticos severos.",
    },
  ]
  dataSublink = [
    {
      position: 51, 
      cont: "a) La prevención de los factores de riesgo psicosocial; ",
      ruta : './step5-sub1-a%29'
    },{
      position: 51, 
      cont: "b) La prevención de la violencia laboral, ",
      ruta : './step5-sub1-b%29'

    },{
      position: 51, 
      cont: "c) La promoción de un entorno organizacional favorable.",
      ruta : './step5-sub1-c%29'
    },{
      position: 57, 
      cont: 'a) La política de prevención de riesgos psicosociales;', 
      ruta : './step7-sub1-a%29'
    },{
      position: 57, 
      cont: "b) Las medidas adoptadas para combatir las prácticas opuestas al entorno organizacional favorable y los actos de violencia laboral;", 
      ruta : './step7-sub1-b%29'
    },{
      position: 57, 
      cont: "c) Las medidas y acciones de prevención y, en su caso, las acciones de control de los factores de riesgo psicosocial; ",
      ruta : './step7-sub1-c%29'
    },{
      position: 57, 
      cont: "d) Los mecanismos para presentar quejas por prácticas opuestas al entorno organizacional favorable y para denunciar actos de violencia laboral;",
      ruta : './step7-sub1-d%29'
    },{
      position: 57, 
      cont: "e) Los resultados de la identificación y análisis de los factores de riesgo psicosocial para los centros de trabajo que tengan entre 16 y 50 trabajadores, y de la identificación y análisis de los factores de riesgo psicosocial y la evaluación del entorno organizacional tratándose de centros de trabajo de más de 50 trabajadores,",
      ruta : './step7-sub1-e%29'
    },{
      position: 57, 
      cont: "f) Las posibles alteraciones a la salud por la exposición a los factores de riesgo psicosocial.",
      ruta : './step7-sub1-f%29'
    },{
      position: 58, 
      cont: "a) Los resultados de la identificación y análisis de los factores de riesgo psicosocial y, además, tratándose de centros de trabajo de más de 50 trabajadores, de las evaluaciones del entorno organizacional;",
      ruta : './step8-sub1-a%29' 
    },{
      position: 58, 
      cont: "b) Las medidas de control adoptadas cuando el resultado de la identificación y análisis de los factores de riesgo psicosocial y evaluación del entorno organizacional lo señale ", 
      ruta : './step8-sub1-b%29' 
    },{
      position: 58, 
      cont: "c) Los nombres de los trabajadores a los que se les practicaron los exámenes o evaluaciones clínicas y que se comprobó la exposición a factores de riesgo psicosocial, a actos de violencia laboral o acontecimientos traumáticos severos.  ",
      ruta : './step8-sub1-c%29' 
    }

  ]

  dataId : any ;
  constructor(private activated: ActivatedRoute) {

   }

  ngOnInit() {
    this.activated.data.subscribe  (params=>{this.dataId = params});
  }

}
